import { newAPI } from 'services';
import qs from 'qs';

export const requestSelfServiceUsers = async (userId, establishmentId, page, qp) => {
  const response = await newAPI.get(`${userId}/establishment/${establishmentId}/self-service/users?page=${page}${qp}`);
  return response.data;
}

export const createSelfServiceUser = async (userId, establishmentId, params) => {
  const response = await newAPI.post(`${userId}/establishment/${establishmentId}/self-service/users/new`, qs.stringify(params));
  return response.data;
}

export const updateSelfServiceUser = async (userId, establishmentId, params, editingUserId) => {
  const response = await newAPI.put(`${userId}/establishment/${establishmentId}/self-service/users/${editingUserId}`, qs.stringify(params));
  return response.data;
}

export const updateSelfServiceSettings = async (userId, establishmentId, params) => {
  const response = await newAPI.put(`${userId}/establishment/${establishmentId}/self-service/settings`, qs.stringify(params));
  return response.data;
}

export const requestSelfServiceSettings = async (userId, establishmentId) => {
  const response = await newAPI.get(`${userId}/establishment/${establishmentId}/self-service/settings`);
  return response.data;
}

export const requestToggleSelfServiceUserStatus = async (userId, establishmentId, targetUserId) => {
  const response = await newAPI.put(`${userId}/establishment/${establishmentId}/self-service/users/${targetUserId}/toggle-status`);
  return response.data;
}